import React, { useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import { z } from 'zod';
import { API_URL } from '../variables';

import '../styles/signinform.css';

const resetPasswordSchema = z.object({
  password: z.string().min(5, { message: "Password must be at least 5 characters long" }),
  confirmPassword: z.string().min(5, { message: "Password must be at least 5 characters long" }),
});

function ResetPasswordForm() {
  const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();

    // get token from url query\
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('t');
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (formData.password.length < 5) {
      toast.error("Password must be at least 5 characters long");
      return;
    }
    try {
      resetPasswordSchema.parse(formData);
      setIsSubmitting(true);
      formData.token = token;
      const response = await axios.post(`${API_URL}/api/users/reset-password`, formData);

      if (response.status === 200) {
        toast.success("Password reset successfully!");
        setSubmitted(true);
      } else {
        toast.error(response.data.message || 'Something went wrong.');
      }
    } catch (error) {
      if (error.name === 'ZodError') {
        toast.error(error.errors[0].message);
      } else if (error.response) {
        toast.error(error.response.data.message || 'An error occurred. Please try again.');
      } else {
        toast.error('An error occurred. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sign-in-container">
      <ToastContainer />
      <div className="sign-in-form">
        <h1 className="sign-in-title">Reset Password</h1>
        <p className="sign-in-subtitle">Recover your <span className="brand-name">K-Shop</span> account</p>

        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="password"
                id="password"
                name="password"
                placeholder="New password..."
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm password..."
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                required
              />
            </div>

            <button
              type="submit"
              className="sign-in-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Reset Password'}
            </button>
            <div className="additional-options">
              <p>Remember your password? <Link to="/signin" className="forgot-password">Sign in</Link></p>
            </div>
          </form>
        ) : (
          <div className="success-message">
            <p>Your password has been reset successfully.</p>
            <div className="additional-options">
              <p><Link to="/signin" className="forgot-password">Back to Sign in</Link></p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default ResetPasswordForm;

